<template>
  <div id="main-app">
    <TopBar></TopBar>
    <Header></Header>
    <b-breadcrumb v-if="navigation && navigation.length > 0" :items="navigation"/>
    <AlertContainer></AlertContainer>
    <main>
      <img  v-show="loading" src="@/assets/loader.svg" class="loader"/>
      <router-view />
    </main>
  </div>
</template>
<script>
require('es6-promise').polyfill()// compatibilité IE
import Header from '@/components/layouts/Header'
import TopBar from '@/components/layouts/TopBar'
import AlertContainer from '@/components/AlertContainer'

import { REFRESH_BADGES, REFRESH_ABILITIES, API_CALL_PENDING, API_CALL_COMPLETE } from '@/lib/enums/events/app'
import { COUNTER_UPDATE } from '@/store/actions/counter'
import defineAbilitiesFor from '@/resources/ability'
import {mapGetters, mapActions} from 'vuex'
import {
  HIGH
} from '@/lib/enums/alert'
import Alert from '@/lib/transfer-objects/Alert'
export default {
  name: 'app',
  data () {
    return {
      pendingApiRequest: 0
    }
  },
  components: {
    Header,
    TopBar,
    AlertContainer
  },
  computed: {
    ...mapGetters({
      currentUser: 'user'
    }),
    ...mapGetters('header', ['navigation']),
    loading: function () {
      return this.pendingApiRequest > 0
    }
  },
  methods: {
    ...mapActions(['setBadges']),
    dashboardSummary () {
      this.$administrationApi.get('/dashboard/summary')
      .then(response => {
        this.$store.dispatch(COUNTER_UPDATE, response.data)
        this.setBadges()
      })
      .catch((error) => {
        console.error('error', error)
        this.$bus.$emit('alert', new Alert('Impossible de récupérer la liste des compteurs', 'une erreur s\'est produite lors de la récupération des compteurs. Veuillez réessayer.', HIGH, 15000))
      })
    }
  },
  watch: {
    currentUser: {
      deep: true,
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.$bus.$emit(REFRESH_BADGES)
        }
      }
    }
  },
  created () {
    var thatVue = this
    this.$bus.$on(REFRESH_ABILITIES, function (user) {
      let ability = defineAbilitiesFor(user.role.code)
      this.$ability.update(ability.rules)
    })
    this.$bus.$on(REFRESH_BADGES, async function () {
      await this.$auth.isAuthenticated().then(response => {
        thatVue.dashboardSummary()
      })
    })
    this.$bus.$on(API_CALL_PENDING, function () {
      thatVue.pendingApiRequest ++
    })
    this.$bus.$on(API_CALL_COMPLETE, function () {
      thatVue.pendingApiRequest --
    })
  },
  mounted () {
  },
  beforeDestroy () {
    [REFRESH_ABILITIES, REFRESH_BADGES, API_CALL_PENDING, API_CALL_COMPLETE].forEach(element => {
      this.$bus.$off(element)
    })
  }
}
</script>
<style lang="sass">
main 
  overflow: auto !important
.loader
  position: fixed
  z-index: 999
  overflow: visible
  margin: auto
  top: 0
  left: 0
  bottom: 0
  right: 0
.main-app
  display: flex
  flex-direction: column

body
  line-height: unset !important // Résolution du confit entre ~normalize.css/normalize.css , ./node_modules/bootstrap/dist/css/bootstrap.min.css et le template ExoSkill
.style-chooser .vs__search::placeholder, .vs__dropdown-toggle, .vs__dropdown-menu
  background: #ffffff !important
</style>




// WEBPACK FOOTER //
// src/App.vue